import { TableContainer, Box } from "@mui/material";
import styled from "styled-components";


export const TableBox = styled(Box)`
.noquotecell{
    height:80px;
    border-bottom: none;
}
.noquotetext{
    margin-left:16%
}
.paginationContainer{
    display: flex;
    justify-content: space-between;
    align-items: center;
    
    h6{
        color: #1B4A83;
        font-weight: 600;
        font-family: "Noto Sans", sans-serif;
        span{
            font-size:14px;
            font-weight: 500;
            color: #000;
            padding-left: 6px;
            font-family: 'Noto Sans', sans-serif;
        }
    }
    button {
        margin: 10px 0;
        border-radius: 2px;
        font-family: "Noto Sans", sans-serif;
}
}
`;

export const TableContainerWrapper = styled(TableContainer)`


.tableContainer{
    padding-left:1px;
    max-height:500px !important;
    table{
     thead{
        background-color: #1B4A83;
        text-wrap: nowrap;
        
        tr{
            th{
                color: #fff;
                font-weight: bold;
                text-align: start;
                padding:12px;
      @media screen and (min-device-width: 1190px) and (max-device-width: 1288px) { 
     font-size: 12px;
     font-weight: 400;

   }
}

.css-1qgma8u-MuiButtonBase-root-MuiTableSortLabel-root.Mui-active .MuiTableSortLabel-icon {
    opacity: 1;
    color: #fff;
}
 .MuiTableSortLabel-icon {
    opacity: 1;
    color:white;
    font-size:20px;
}

                .filterBar{
                    margin: -5px 8px;
                    font-size: 18px;
                        @media screen and (min-device-width: 1190px) and (max-device-width: 1288px) { 
    margin: -3px 8px;
 font-size: 16px;

 }
                }
            }
        }
     }
     tbody{
        text-wrap: nowrap;
        tr{
            td{
                text-align: start;
                svg{

                }
            }
            th{

            }
        }
    }

}

}
.noDataRow{
    border-bottom:none;
}
`;


export const statusColors = {
    'Pending Approval': '#8A9123',
    'Pending Initial Requestor': '#E27900',
    'Approved': '#00AF97',
    'Submitted': '#239155',
    'Contracted': '#91238D',
    // Add more status values and colors as needed
  };
